import { Card } from "primereact/card";
import { Link, useParams } from "react-router-dom";

const EntitySettingsSideBar = ({ activeTab }) => {
  const { id } = useParams();

  return (
    <>
      <Card className="card-style h-full p-0">
        <div className="flex flex-column">
          <Link
            to={`/entity/${id}/entity-settings/active-services`}
            className={`sidebar-align ${activeTab === "active-services" ? "active-entity" : "menu-hover"}`}
          >
            <div className="flex align-items-center">
              <p className="sidebar-menu">Active Services</p>
            </div>
            <span className="pi pi-angle-right icon-color"></span>
          </Link>
        </div>
      </Card>
    </>
  );
};

export default EntitySettingsSideBar;
